import BrButton from '@govbr/react-components/lib/BrButton';
import BrSelect from '@govbr/react-components/lib/BrSelect';
import { Grid } from '@material-ui/core';
import { useCallback, useEffect, useState } from 'react';
import _ from 'underscore';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import Card from '../../components/Card/Card';
import MainContainer from '../../components/MainContainer/MainContainer';
import { ConsultaPostoAtendimentoModel } from '../../model/consultaPostoAtendimento';
import { TipoOrdenacao } from '../../model/TipoOrdenacao';
import { getLocation } from '../../util/localizacao.util';
import styles from './PostoAtendimento.module.css';
import Message from '../../components/Message/Message';
import {
  getMunicipios,
  getPostosAtendimentoPeloMunicipio,
  getUfs,
  limpar,
  selectMunicipios,
  selectPostosAtendimento,
  selectUfs,
  alterarMensagem,
  ativarMensagem,
  selectState,
  selectComunicacaoAPI,
  selectVersaoMinimaAceitavel,
} from './PostoAtendimentoSlice';
import { setLoading, selectLoadingCount } from '../../globalSlice';
import imgErro from '../../assets/img/icone-erro.png';
import imgAlerta from '../../assets/img/icone-alerta.png';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useHistory } from 'react-router-dom';
import * as mensagens from '../../common/Mensagens'
import { selectPerfilCompleto, selectSituacaoCadastroFamilia } from '../Perfil/perfilSlice';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import { selectLogado } from '../IdentificacaoPositiva/identificacaoPositivaSlice';
import configuration from '../../envConfig';
import { APPLE_STORE_LINK, GOOGLE_PLAY_LINK } from '../../common/storeUtil';
import { obterNomeDoPerfil } from '../../common/perfilUtils';
import { trackServiceSelect } from '../../common/tracker';
import useConnectionStatus from '../../common/ConnectionStatus/ConnectionStatus';
import InternetConnectionError from '../../components/ConnectionStatus/ConnectionError';

const tiposPostosAtendimento = ['Todos', 'CRAS', 'CREAS', 'CENTRO POP', 'POSTOS DO CADASTRO ÚNICO'];

const PostoAtendimento: React.FC = (props) => {
  const connectionStatus = useConnectionStatus()

  const dispatch = useAppDispatch();
  const state = useAppSelector(selectState);

  const ufs = useAppSelector(selectUfs);
  const municipios = useAppSelector(selectMunicipios);
  const postosAtendimento = useAppSelector(selectPostosAtendimento);

  const [ufSelecionado, setUfSelecionado] = useState(null);
  const [municipioSelecionado, setMunicipioSelecionado] = useState(null);
  const [tipoPostoSelecionado, setTipoPostoSelecionado] = useState(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [tipoOrdenacao, setTipoOrdenacao] = useState(TipoOrdenacao.NOME);
  const temComunicacaoComAPI = useAppSelector(selectComunicacaoAPI);
  const temVersaoMinimaAceitavel = useAppSelector(selectVersaoMinimaAceitavel);
  const loadingCount = useAppSelector(selectLoadingCount);
  const history = useHistory();

  const perfil = useAppSelector(selectPerfilCompleto);
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);

  useEffect(() => {
    dispatch(getUfs());
    obterLocalizacaoAtual();
    return () => {
      dispatch(limpar());
      dispatch(alterarMensagem(''));
      dispatch(ativarMensagem(false));
    };
  }, [dispatch]);

  const limparMensagens = () => {
    dispatch(alterarMensagem(''));
    dispatch(ativarMensagem(false));
  };

  const obterMensagemComTipo = (mensagem) => {
    setTimeout(() => {
      dispatch(ativarMensagem(false));
    }, 1000000);

    return (
      <div onClick={() => limparMensagens()}>
        <Message id="mensagem" type="warning" title={mensagem} className={styles.message} />
      </div>
    );
  };

  const buscar = useCallback(() => {
    let consultaPostoAtendimentoModel: ConsultaPostoAtendimentoModel = {
      uf: ufSelecionado,
      numeroIbgeMunicipio: municipioSelecionado,
      latitude: lat,
      longitude: lng,
      tipoPosto: tipoPostoSelecionado,
      tipoOrdenacao: tipoOrdenacao,
    };

    dispatch(getPostosAtendimentoPeloMunicipio(consultaPostoAtendimentoModel));
  }, [
    dispatch,
    ufSelecionado,
    municipioSelecionado,
    tipoPostoSelecionado,
    tipoOrdenacao,
    lat,
    lng,
  ]);

  useEffect(() => {
    if (ufSelecionado && municipioSelecionado) {
      buscar();
    }
  }, [buscar, ufSelecionado, municipioSelecionado]);

  const handleSelecionarUF = (value) => {
    if (value === null) {
      setUfSelecionado(null);
      setMunicipioSelecionado(null);
      setTipoPostoSelecionado(null);
      return dispatch(limpar());
    }
    dispatch(alterarMensagem(''));
    dispatch(getMunicipios(value.codigoUfIbge));
    setUfSelecionado(value.siglaUf);
    setMunicipioSelecionado(null);
    //setTipoPostoSelecionado(null);
  };

  const handleSelecionarMunicipio = (value) => {
    dispatch(alterarMensagem(''));
    setMunicipioSelecionado(value);
  };

  const handleSelecionarTipoPosto = (value) => {
    dispatch(alterarMensagem(''));
    setTipoPostoSelecionado(value);
  };

  const abrirLocalizacao = (data: any) => {
    if (!data.latitude || !data.longitude) {
      return;
    }
    dispatch(setLoading(true));
    getLocation(
      (position) => {
        let url =
          'https://maps.google.com/maps?saddr=' +
          position.coords.latitude +
          ',' +
          position.coords.longitude +
          '&daddr=' +
          data.latitude +
          ',' +
          data.longitude;
        window.open(url, '_system');
        dispatch(setLoading(false));
      },
      (error) => {
        console.log(error);
        let url = 'https://maps.google.com/maps?daddr=' + data.latitude + ',' + data.longitude;
        window.open(url, '_system');
        dispatch(setLoading(false));
      }
    );
  };

  const obterLocalizacaoAtual = () => {
    getLocation(
      (position) => {
        setLat(position.coords.latitude);
        setLng(position.coords.longitude);
        setTipoOrdenacao(TipoOrdenacao.DISTANCIA);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const obterValueTipoPostoSelecionado = () => {
    if (tipoPostoSelecionado) {
      return tiposPostosAtendimento.find((tipoPosto) =>
        tipoPosto === tipoPostoSelecionado
          ? {
              label: tipoPosto,
              value: tipoPosto,
            }
          : {
              label: tipoPosto,
              value: tipoPosto,
            }
      );
    }
  };

  const obterValueUfSelecionada = () => {
    if (ufSelecionado) {
      return ufs.find((uf) =>
        uf.siglaUf === ufSelecionado
          ? {
              label: uf.nomeUf,
              value: uf,
            }
          : {
              label: uf.nomeUf,
              value: uf,
            }
      );
    }
  };

  const ordenarLista = () => {
    if (tipoOrdenacao === TipoOrdenacao.NOME) {
      setTipoOrdenacao(TipoOrdenacao.DISTANCIA);
    } else {
      setTipoOrdenacao(TipoOrdenacao.NOME);
    }
  };

  const obterValueMunicipioSelecionado = () => {
    const municipio = _.findWhere(municipios, { codigoMunicipioIbge: municipioSelecionado });
    if (municipio) {
      return { label: municipio.nomeMunicipio, value: municipio.codigoMunicipioIbge };
    }
    return null;
  };

  const montarSelectUF = () => {
    return (
      <BrSelect
        id="ufs"
        placeholder="UF"
        label="Estado"
        value={ufs ? obterValueUfSelecionada() : ''}
        items={ufs.map((uf) => ({ label: uf.siglaUf, value: uf }))}
        onChange={(event) => handleSelecionarUF(event)}
      />
    );
  };

  const montarSelectMunicipios = () => {
    return (
      <BrSelect
        id="municipios"
        placeholder="Município"
        label="Município"
        disabled={!municipios || municipios.length === 0}
        value={municipios ? obterValueMunicipioSelecionado() : ''}
        items={municipios.map((municipio) => ({
          label: municipio.nomeMunicipio,
          value: municipio.codigoMunicipioIbge,
        }))}
        onChange={(event) => handleSelecionarMunicipio(event)}
      />
    );
  };

  const montarSelectTipoPosto = () => {
    return (
      <BrSelect
        id="tiposPostos"
        placeholder="Tipo Posto"
        label="Tipo Posto"
        disabled={!ufSelecionado}
        defaultValue={{ label: 'Todos', value: null }}
        value={tiposPostosAtendimento ? obterValueTipoPostoSelecionado() : ''}
        items={tiposPostosAtendimento.map((tipoPosto) => {
          return {
            label: tipoPosto,
            value: tipoPosto !== 'Todos' ? tipoPosto : null,
          };
        })}
        onChange={(event) => handleSelecionarTipoPosto(event)}
      />
    );
  };

  const exibirPostosAtendimento = () => {
    return (
      <Card>
        {postosAtendimento && postosAtendimento.length > 0 && lat && lng && (
          <>
            <BrButton
              id="botaoOrdenacao"
              className={styles.botaoOrdenacao}
              onClick={() => ordenarLista()}
            >
              {tipoOrdenacao === TipoOrdenacao.DISTANCIA && 'Mais próximo'}
              {tipoOrdenacao === TipoOrdenacao.NOME && 'Por nome'}
              <i className="fas fa-arrow-down"></i>
            </BrButton>
            <hr />
          </>
        )}
        {postosAtendimento.map((data, id) => {
          return (
            <div key={id}>
              <div
                className={`${data.latitude || data.longitude ? styles.postoWrapper : ''}`}
                onClick={() => abrirLocalizacao(data)}
              >
                <div className={styles.postoTitleWrapper}>
                  <div className={styles.postoTitle}>{data.nomePostoAtendimento}</div>
                  {(data.latitude || data.longitude) && (
                    <i className={`fas fa-map-marker-alt ${styles.iconPin}`} />
                  )}
                </div>
                {data.distanciaReferencia && (
                  <div>Distância: {data.distanciaReferencia} Km (aproximada)</div>
                )}
                <div>{data.enderecoCompleto}</div>
                <div>{data.nomeBairro}</div>
                <div>{data.nomeMunicipio}</div>
              </div>
              <hr />
            </div>
          );
        })}
      </Card>
    );
  };

  const isLogado = () => {
    return (govBrLogado && situacaoCadastroFamilia) || isAuthenticatedIdPositiva
      ? true
      : false;
  }

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const caixaMensagens = () => {
    trackServiceSelect('POR-MENU', "CAIXA DE MENSAGEM");
    history.push('/caixa-mensagem');
  };

  const fecharMensagemAtualizacaoApp = () => {
    if (configuration.isCordova) {
      if (configuration.device.platform === 'IOS') {
        window.open(APPLE_STORE_LINK, '_system', 'location=yes');
      } else {
        window.open(GOOGLE_PLAY_LINK, '_system', 'location=yes');
      }
    }

    history.replace('/home');
  };

  return (
    <MainContainer
      barraAuxiliar={true}
      navTitle={obterNomeDoPerfil(perfil, situacaoCadastroFamilia)}
      padraoInicial={!isLogado()}
      stoppedTitle={true}
      navHideArrow={false}
      userNav={isLogado()}
      titleBarraAuxiliar={'Postos de atendimento'}
      navFixed={isLogado()}
      navGoBack={() => history.goBack()}
      navCaixaMensagens={isLogado() ? caixaMensagens : undefined}
      navLogout={isLogado() ? logout : undefined}
      navSeparator
    >
      <div className={styles.container}>
        {loadingCount > 0 && !temComunicacaoComAPI && (
          <Card className={styles.card}>
            <Skeleton count={15} />
          </Card>
        )}

        {!connectionStatus.isOnline && (
          <InternetConnectionError />
        )}

        {/**
         * Mostrando mensagem para atualização do app quando a versão estiver desatualizada.
         */}
        {connectionStatus.isOnline && loadingCount < 1 && !temComunicacaoComAPI && !temVersaoMinimaAceitavel && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgAlerta} alt="Imagem"/>
              <Message
                type={'warning'}
                text={
                  configuration.isCordova ? (
                    mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA
                  ) : (
                    mensagens.MSG_ERRO_VERSAO_MINIMA_NAO_ATENDIDA_WEB
                  )
                }
              />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => fecharMensagemAtualizacaoApp()} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {/**
         * Mostrando mensagem de falta de comunicação com a API.
         */}
        {connectionStatus.isOnline && loadingCount < 1 && !temComunicacaoComAPI && temVersaoMinimaAceitavel && (
          <Card className={styles.card}>
            <div className={styles.containerMensagem}>
              <img className={styles.imgMessage} src={imgErro} alt="Imagem" />
              <Message
                type={'error'}
                text={mensagens.MSG_ERRO_COMUNICACAO_API}
              />
              <div className={styles.botaoContainer}>
                <BrButton onClick={() => history.replace('/home')} className={styles.botao}>
                  OK
                </BrButton>
              </div>
            </div>
          </Card>
        )}

        {connectionStatus.isOnline && temComunicacaoComAPI && (
          <Card>
            <Grid container spacing={2}>
              <Grid item xs={4} md={2}>
                {montarSelectUF()}
              </Grid>
              <Grid item xs={8} md={4}>
                {montarSelectMunicipios()}
              </Grid>
              <Grid item xs={12} md={6}>
                {montarSelectTipoPosto()}
              </Grid>
            </Grid>
          </Card>
        )}
        {temComunicacaoComAPI && state.ativarMensagem && obterMensagemComTipo(state.mensagem)}
        {temComunicacaoComAPI &&
          postosAtendimento &&
          postosAtendimento.length > 0 &&
          exibirPostosAtendimento()}
      </div>
    </MainContainer>
  );
};

export default PostoAtendimento;
